import { Alert } from "../../../core/Alert.js";
import type { BattleNoticeContent } from "../battlesContent.js";

/**
 * Why the shopper's last action didn't happen (not enough balance, the seat was just taken),
 * announced and written above the controls until the next try.
 */
export function BattleNotice({ message }: BattleNoticeContent) {
  return <Alert tone="danger">{message}</Alert>;
}
